import { createSlice } from "@reduxjs/toolkit";
import authApi from "interceptor/authInterceptor";
import { dispatch } from "store";
import toast from "utils/ToastNotistack";
import { PAGINATION } from "utils/constants/pagination";

interface InitialState {
  employees: Array<object>;
  page: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  loader: boolean;
}
const initialState: InitialState = {
  employees: [],
  page: PAGINATION.INITIAL_PAGE,
  pageSize: PAGINATION.ROWS_PER_PAGE,
  totalRecords: 0,
  totalPages: 0,
  loader: false,
};

const registeredEmployees = createSlice({
  name: "registeredEmployees",
  initialState,
  reducers: {
    getEmployees: (state, action) => {
      const { employees, page, pageSize, totalRecords, totalPages } =
        action.payload;
      state.employees = employees;
      state.page = page;
      state.pageSize = pageSize;
      state.totalRecords = totalRecords;
      state.totalPages = totalPages;
    },
       isLoading(state, action) {
      state.loader = action.payload;
    },
    clearRegisteredEmployees: () => initialState,
  },
});

export const { getEmployees, isLoading, clearRegisteredEmployees } =
  registeredEmployees.actions;

export default registeredEmployees.reducer;



export function fetchRegisteredEmployees(
  page: number,
  pageSize: number,
  companyId: string,
  employeeName?: string,
  businessUnitId?: string
) {
  return async () => {
    try {
      dispatch(isLoading(true));
    const response = await authApi.get(
      `/v2/api/users/registered?page=${page}&pageSize=${pageSize}&companyId=${companyId}&employeeName=${
        employeeName ? employeeName : ""
      }&businessUnitId=${businessUnitId ? businessUnitId : ""}`
    );

    if (response.data) {
      dispatch(
        getEmployees({
          employees: response.data.data,
          page: response.data.page,
          pageSize: response.data.pageSize,
          totalRecords: response.data.totalRecords,
          totalPages: response.data.totalPages,
        })
      );
    }
    } catch (error) {
      console.error("Error fetching registered employees:", error);
      toast("Failed to load employees data", { variant: "error" });
    } finally {
      dispatch(isLoading(false));
    }
  };
}

export function deleteEmployeeProfile(staffId: any) {
  return async () => {
    const response = await authApi.delete(`/v2/api/users/${staffId}`);
    if (response.data) {
      toast(response.data.message, { variant: "success" });
    }
  };
}

export function blockEmployee(userId: any) {
  return async () => {
    const response = await authApi.post(`/v2/api/users/block/${userId}`);
    if (response.data) {
      toast(response.data.message, { variant: "success" });
    }
  };
}

export function unBlockEmployee(userId: any) {
  return async () => {
    const response = await authApi.post(`/v2/api/users/unblock/${userId}`);
    if (response.data) {
      toast(response.data.message, { variant: "success" });
    }
  };
}
